var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('detail-header',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"bubble",staticStyle:{"padding-top":"50px"}},[_c('user-card',{attrs:{"user":_vm.user}}),_c('account')],1),_c('common-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }